import { markAnswer as markMultipleChoiceAnswer } from "../../multiplechoice/logic/answers";
import { checkWord } from "../../wordfill/logic/answers";
import { TestableSentence } from "../../wordfill/types/index";
import { Answer, Content, Score } from "../types";

export const checkAnswers = (valObj: TestableSentence, wordAnswer: string) => {
  const testableWord = (valObj as any).value.filter(
    (o: any) => typeof o !== "string"
  )[0];
  return [testableWord.word]
    .concat(testableWord.otherPermittedWords)
    .some(w => checkWord(w, wordAnswer));
};

export function markAnswer(content: Content, answer: Answer): Score {
  let listScoreCount = 0;
  const hits = content.list.values.map(() => false);
  if (!answer)
    return {
      score: 0,
      multipleChoice: {
        score: 0
      },
      list: {
        score: 0,
        hits
      }
    };
  const multipleChoiceAnswered = answer.multipleChoice.index !== null;
  const multipleChoiceScoreObj = multipleChoiceAnswered
    ? markMultipleChoiceAnswer(
        (content as any).multipleChoice,
        answer.multipleChoice
      )
    : {
        score: 0
      };
  const multipleChoiceScore = multipleChoiceScoreObj.score;
  content.list.values.forEach((valObj, index) => {
    for (const wordAnswer of answer.list) {
      if (valObj.testing && checkAnswers(valObj as any, wordAnswer)) {
        listScoreCount++;
        hits[index] = true;
        break;
      }
    }
  });
  let testedValuesCount = content.list.values.filter(
    valObj => valObj.testing
  ).length;

  if (!answer.list.length) {
    // gave up
    return {
      score: Number(
        (multipleChoiceScore! / (1 + testedValuesCount)).toFixed(2)
      ),
      multipleChoice: multipleChoiceScoreObj,
      list: {
        score: 0,
        hits
      }
    };
  }

  const listScore =
    listScoreCount === 0
      ? 0
      : Number((listScoreCount / testedValuesCount).toFixed(4));
  if (multipleChoiceAnswered) testedValuesCount++;
  let overallScore;

  if (listScoreCount === 0 && multipleChoiceScore === 0) {
    overallScore = 0;
  } else if (listScore === 1.0 && multipleChoiceScore === 1) {
    overallScore = 1;
  } else {
    overallScore = (
      (listScoreCount + multipleChoiceScore!) /
      testedValuesCount
    ).toFixed(2);
  }

  return {
    score: Number(overallScore),
    multipleChoice: multipleChoiceScoreObj,
    list: {
      score: listScore,
      hits
    }
  };
}
